import { Alert } from "antd";
import { useEffect, useRef } from "react";
import { useMaintenanceFlag } from "../hooks/useMaintenanceFlag";

const DEFAULT_MESSAGE =
  "Scheduled maintenance in progress — some features may be temporarily unavailable.";

export default function MaintenanceBanner() {
  const { active, message } = useMaintenanceFlag();
  const containerRef = useRef(null);

  // While the banner is active, push the rest of the page down by the
  // banner's measured height so the fixed bar doesn't overlay the
  // navbar / login form. ResizeObserver keeps the offset in sync when
  // copy wraps on narrow viewports.
  useEffect(() => {
    if (!active) {
      document.body.style.paddingTop = "";
      return undefined;
    }
    const apply = () => {
      const h = containerRef.current?.offsetHeight ?? 0;
      document.body.style.paddingTop = h ? `${h}px` : "";
    };
    apply();
    let observer;
    if (typeof ResizeObserver !== "undefined" && containerRef.current) {
      observer = new ResizeObserver(apply);
      observer.observe(containerRef.current);
    }
    return () => {
      observer?.disconnect();
      document.body.style.paddingTop = "";
    };
  }, [active]);

  if (!active) return null;

  return (
    <div
      ref={containerRef}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1100,
      }}
    >
      <Alert
        type="warning"
        showIcon
        banner
        message={message || DEFAULT_MESSAGE}
        role="status"
        aria-live="polite"
      />
    </div>
  );
}
